import _permissao from "@universidade-franciscana/componente-front/src/enums/permissao.js"

export default [{
     path: "/tabela",
    name: "tabela",
    component: () => import("@/view/tabela/Tabela.vue"),
    meta: {
      titulo: "Tabela",
      caminho:"tabela",
      tipoPermissao: _permissao.LISTAR,
      breadcrumb: [
        { text: "Tabela", disabled: false, to: "/" },
      ],
    },
  },

  {
     path: "/tabelaItem/:id",
    name: "Tabela-Item",
    component: () => import("@/view/tabelaItem/TabelaItem.vue"),
    meta: {
      titulo: "Tabela Item",
      caminho: "tabela",
      tipoPermissao: _permissao.LISTAR,
      breadcrumb: [
        { text: "Tabela", disabled: false, to: "/tabela" },
        { text: "TabelaItem", disabled: false },
      ],
    },
  },
  {
     path: "/tabelaItem/",
    name: "Tabela-Item",
    component: () => import("@/view/tabelaItem/TabelaItem.vue"),
    meta: {
        titulo: "Tabela Item",
        caminho: "tabela",
        tipoPermissao: _permissao.LISTAR,
        breadcrumb: [
        { text: "Tabela", disabled: false, to: "/tabela" },
        { text: "TabelaItem", disabled: false },
      ],
    },
  },
]